namespace GeniuzPOS.InitialData {
    export namespace PsPosTouchPanelTypeService {
        export const baseUrl = 'InitialData/PsPosTouchPanelType';

        export declare function Create(request: Serenity.SaveRequest<PsPosTouchPanelTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPosTouchPanelTypeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPosTouchPanelTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPosTouchPanelTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsPosTouchPanelType/Create",
            Update = "InitialData/PsPosTouchPanelType/Update",
            Delete = "InitialData/PsPosTouchPanelType/Delete",
            Retrieve = "InitialData/PsPosTouchPanelType/Retrieve",
            List = "InitialData/PsPosTouchPanelType/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPosTouchPanelTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
